import { IEventMarketGoalFromWS } from '@/types/event';
import { BetSelection } from '@/constants';
import { AbstractMarket } from '@/models/abstractMarket';

export class MarketGoalItem extends AbstractMarket {
    public handicap: string;
    public overPrice: string | null;
    public underPrice: string | null;
    public overBookmakerId: number | null;
    public underBookmakerId: number | null;
    public overPriceList: [number, number][] | null;
    public underPriceList: [number, number][] | null;
    public feedCount: number;
    public marginPerc: string | null;

    constructor(data: IEventMarketGoalFromWS) {
        super();

        this.setPreviousPrice(BetSelection.GoalOver, data.price_over_max);
        this.setPreviousPrice(BetSelection.GoalUnder, data.price_under_max);

        this.overPrice = data.price_over_max;
        this.underPrice = data.price_under_max;
        this.overBookmakerId = data.price_over_max_site_id;
        this.underBookmakerId = data.price_under_max_site_id;
        this.overPriceList = data.price_over_list ? JSON.parse(data.price_over_list) : null;
        this.underPriceList = data.price_under_list ? JSON.parse(data.price_under_list) : null;
        this.handicap = data.handicap;
        this.feedCount = data.feeds_count;
        this.marginPerc = data.margin_perc;
    }

    public update(data: IEventMarketGoalFromWS) {
        this.setPreviousPrice(BetSelection.GoalOver, this.overPrice);
        this.setPreviousPrice(BetSelection.GoalUnder, this.underPrice);

        this.overPrice = data.price_over_max;
        this.underPrice = data.price_under_max;
        this.overBookmakerId = data.price_over_max_site_id;
        this.underBookmakerId = data.price_under_max_site_id;
        this.overPriceList = data.price_over_list ? JSON.parse(data.price_over_list) : null;
        this.underPriceList = data.price_under_list ? JSON.parse(data.price_under_list) : null;
        this.handicap = data.handicap;
        this.feedCount = data.feeds_count;
        this.marginPerc = data.margin_perc;
    }
}
